"use strict";
import { isProdEnv } from "utilities/src/environment/env";
function isAppUniswapOrg({ hostname }) {
  return hostname === "app.topazdex.com";
}
function isAppUniswapStagingOrg({ hostname }) {
  return hostname === "app.corn-staging.com";
}
function isIpfs({ hostname }) {
  return hostname.includes("ipfs") || hostname.includes("topaz.eth") || hostname.includes("ipns");
}
export function isBrowserRouterEnabled() {
  if (isIpfs(window.location)) {
    return false;
  }
  if (isProdEnv()) {
    if (isAppUniswapOrg(window.location) || isAppUniswapStagingOrg(window.location) || isLocalhost(window.location)) {
      return true;
    }
    return false;
  }
  return true;
}
function isLocalhost({ hostname }) {
  return hostname === "localhost";
}
export function isRemoteReportingEnabled() {
  return false;
}
